module.exports = __webpack_public_path__ + "static/media/zh.860cee4f.svg";